import styled from "styled-components";

import { FontStyle } from "../FontStyle";

export const AvatarGroupsStyles = styled.div<{
  hasTooltip: boolean;
}>`
  ${FontStyle}
  align-items: center;
  align-items: center;
  border-radius: var(--ac-br-6);
  cursor: ${({ hasTooltip }) => (hasTooltip ? "default" : "pointer")};
  display: flex;
  justify-content: center;
  padding: ${({ hasTooltip }) => (hasTooltip ? "5px 0" : "5px")};
  user-select: none;
  width: fit-content;

  &:hover {
    background-color: ${(props) =>
      !props.hasTooltip && "var(--color-theme-300)"};
    transition: all 0.2s ease-in-out;
  }
`;

interface LengthCountStylesProps {
  size: number;
}

export const LengthCountStyles = styled.div<LengthCountStylesProps>`
  align-items: center;
  background-color: var(--color-theme-400);
  block-size: ${(props) => props.size + "px"};
  border-radius: var(--ac-br-rounded);
  display: flex;
  inline-size: ${(props) => props.size + "px"};
  justify-content: center;
  outline: 1px solid var(--page-paper-main);
  z-index: 99;
`;
